import React from 'react';
import '../styles/components/ServiceDetailModal.css';

const ServiceDetailModal = ({ service, isOpen, onClose, onViewPortfolio, onGetQuote }) => {
  if (!isOpen || !service) return null;

  return (
    <div className="service-modal-overlay" onClick={onClose}>
      <div className="service-modal" onClick={e => e.stopPropagation()} style={{ '--service-color': service.color }}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-header" style={{ backgroundColor: service.color }}>
          <div className="modal-icon" style={{ backgroundColor: service.color }}>
            <span>{service.icon}</span>
          </div>
          <h2>{service.title}</h2>
        </div>

        <div className="modal-content">
          <div className="modal-image">
            <img src={service.image} alt={service.title} />
            <p className="modal-description">{service.description}</p>
          </div>

          <div className="modal-details">
            <div className="modal-features">
              <h4>Key Features</h4>
              <ul className="features-grid">
                {service.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

              <div className="specs-grid">
                <div className="spec-item">
                  <span className="spec-label">Material:</span>
                  <span className="spec-value">{service.specifications.material}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Thickness:</span>
                  <span className="spec-value">{service.specifications.thickness}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Width:</span>
                  <span className="spec-value">{service.specifications.width}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Durability:</span>
                  <span className="spec-value">{service.specifications.durability}</span>
                </div>
            </div>

          </div>
        </div>

        <div className="modal-actions">
          <button
            className="modal-portfolio-btn"
            onClick={onViewPortfolio}
            aria-label="View Portfolio"
          >
            <img
              src="https://img.icons8.com/ios-filled/24/ffffff/paint-palette.png"
              alt="Palette Icon"
              style={{ marginRight: '8px' }}
            />
            View Portfolio
          </button>
          <button
            className="modal-quote-btn"
            onClick={onGetQuote}
            aria-label="Get Quote"
          >
            <img
              src="https://img.icons8.com/ios-filled/24/ffffff/handshake.png"
              alt="Handshake Icon"
              style={{ marginRight: '8px' }}
            />
            Get Quote
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailModal;
